import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { ShowFriendbuyWidget } from 'components/CallToAction/actions';
export var ReferAFriendBanner =
/*#__PURE__*/
function (_Component) {
  _inherits(ReferAFriendBanner, _Component);

  function ReferAFriendBanner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ReferAFriendBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ReferAFriendBanner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return ga('Refer-a-Friend', 'raf-banner-click', window.location.pathname, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      ga('Refer-a-Friend', 'raf-banner-close', window.location.pathname);

      _this.props.onClose();
    });

    return _this;
  }

  _createClass(ReferAFriendBanner, [{
    key: "render",
    value: function render() {
      var rafSenderReward = this.props.rafSenderReward;
      return React.createElement("div", {
        className: "banner banner--promo"
      }, React.createElement(ShowFriendbuyWidget, {
        className: "banner__link--with-guillemet link--stealth",
        onClick: this.handleClick
      }, React.createElement(FormattedMessage, {
        id: "banner.raf.message",
        defaultMessage: "Refer friends to get {rafSenderReward}",
        values: {
          rafSenderReward: rafSenderReward
        }
      })), React.createElement("span", {
        className: "banner__close",
        onClick: this.handleClose
      }, "x"));
    }
  }]);

  return ReferAFriendBanner;
}(Component);
ReferAFriendBanner.propTypes = {
  rafSenderReward: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};